import { useSyncExternalStore } from "react";

export const MOBILE_SIDEBAR_QUERY = "(max-width: 899.95px)";

const subscribe = (onStoreChange: () => void) => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => {};
  }

  const mediaQuery = window.matchMedia(MOBILE_SIDEBAR_QUERY);
  mediaQuery.addEventListener("change", onStoreChange);
  return () => mediaQuery.removeEventListener("change", onStoreChange);
};

const getSnapshot = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(MOBILE_SIDEBAR_QUERY).matches;

const getServerSnapshot = () => false;

export const useIsMobileSidebar = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
